<template>
  <div class="cxbm">
    <Header title="重修报名" type="0" route="/new/Home"></Header>
    <div class="xnxq" @click="xnxqFuct">
      <span>{{ xnxqName }}</span>
      <img src="@/assets/images/aroow.png" alt="">
    </div>
    <NOdata title="暂无记录~" v-if="cxList.length == 0"></NOdata>
    <div v-else>
      <div class="list" v-for="(item,index) in cxList" :key="index">
        <div class="text-one">
          <span>{{item.kcmc}}</span>
          <p>学年学期：{{ item.xqmc }}</p>
        </div>
        <div class="list-all">
          <div class="list-lb">
            <!-- <div class="lb-li">
              <span>重修报名类别</span>
              <img src="@/assets/images/dg-success.png" alt="">
            </div> -->
            <div class="lb-li">
              <span>是否报名</span>
              <span>{{ item.sfbmxs }}</span>
              <!-- <img src="@/assets/images/dg-success.png" alt=""> -->
            </div>
            <div class="lb-li">
              <span>是否选课</span>
              <span>{{ item.sfxkxs }}</span>
              <!-- <img src="@/assets/images/dg-success.png" alt=""> -->
            </div>
            <div class="lb-li">
              <span>是否缴费</span>
              <span>{{ item.sfjfxs }}</span>
              <!-- <img src="@/assets/images/dg-success.png" alt=""> -->
            </div>
            <div class="lb-li">
              <span>是否收费</span>
              <span>{{ item.sfsf }}</span>
              <!-- <img src="@/assets/images/dg-success.png" alt=""> -->
            </div>
          </div>
          <div class="list-text">应收金额：<span>￥{{item.jfjen?item.jfjen:0}}</span></div>
        </div>
        <div class="button-foot">
          <van-button
            class="foot-bm"
            v-if="sfkbm && item.sfbm==='0'"
            type="default"
            @click="bmFuct(item)"
          >报名</van-button>
          <van-button
            class="foot-bm"
            v-if="sfkbm && item.sfbm==='1' && item.sfjf=='0' && item.skys=='0' && item.kkys=='0' && item.sfxk=='0'"
            type="default"
            @click="qxbmFuct(item)"
          >取消报名</van-button>
        </div>
      </div>
    </div>
    <van-popup class="qzPicker" v-model="showXnxq" round position="bottom">
      <van-picker
        show-toolbar
        title="学年学期"
        :columns="columns"
        @cancel="showXnxq = false"
        @confirm="onXnxqConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Api } from "@/utils/axios";
export default{
  data(){
    return{
      showXnxq:false,
      xnxqName:'',
      xnxqVal:'',
      columns:[],
      cxList:[],
      sfkbm:false,
      sfxk:'',
    }
  },
  created() {
    this.getData()
  },
  methods:{
    async getData(){
      const res = await Api.getCxbmXnxq()
      this.columns = res.xnxq01List.map(i=>{
        if(i.sfdqxq === 1){
          this.xnxqVal = i.xnxq01id
          this.xnxqName = i.xqmc
          this.getSearchData(i.xnxq01id)
        }
        return {
          text:i.xqmc,
          value:i.xnxq01id
        }
      })
    },
    async getSearchData(val){
      const res = await Api.getCxbmList({xnxq01id:val})
      this.sfkbm = res.sfkbm
      this.sfxk = res.sfxk
      this.cxList = res.dataList
    },
    xnxqFuct(){
      this.showXnxq = true
    },
    onXnxqConfirm(val){
      this.xnxqName = val.text
      this.xnxqVal = val.value
      this.showXnxq = false
      this.getSearchData(val.value)
    },
    bmFuct(data){
      Dialog.confirm({
            message: "是否重修报名此课程?"
        }).then(() => {
          console.log(123,{
            operate:'bm',
            sfxk:this.sfxk,
            jx0404id:data.jx0404id,
            kcid:data.kcid,
            xnxq01id:data.shxq,
            id:data.cj0721id
          })
          Api.getCxbmSave({
            operate:'bm',
            sfxk:this.sfxk,
            jx0404id:data.jx0404id,
            kcid:data.kcid,
            xnxq01id:data.shxq,
            id:data.cj0721id
          }).then(res=>{
            this.$toast(res.Msg);
            this.getSearchData(this.xnxqVal)
          })
        }).catch(() => {});
    },
    qxbmFuct(data){
      Dialog.confirm({
            message: "是否取消报名此课程?"
        }).then(() => {
          Api.getCxbmSave({
            operate:'qx',
            id:data.cj0721id
          }).then(res=>{
            this.$toast(res.Msg);
            this.getSearchData(this.xnxqVal)
          })
        }).catch(() => {});
    },
  }
}
</script>
<style lang="less" scoped>
.cxbm{
  width: 100%;
  height: calc(100vh - 0.63rem);
  overflow-y: scroll;
  background: #f0f0f2;
  padding:0.63rem 0.88rem;
  box-sizing: border-box;
  .xnxq{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:0.56rem 0.63rem;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    span{
      color:#333;
      font-size: 0.9rem;
    }
  }
  .list{
    width: 100%;
    background: #fff;
    border-radius: 0.5rem;
    margin-top:0.63rem;
    .text-one{
      padding:0.88rem 0.94rem 0.63rem;
      box-sizing: border-box;
      span{
        color:#333;
        font-weight: 600;
        font-size: 1rem;
        line-height: 1;
        display: block;
        margin-bottom:0.6rem;
      }
      p{
        color: #666;
        font-size: 0.75rem;
        line-height: 1;
        margin-bottom:0.4rem;
      }
    }
    .list-all{
      margin:0 0.38rem;
      background-image:linear-gradient(90deg,rgba(116,105,248,0.06) 0%,rgba(116,105,248,0.02) 100%);
      border-radius: 0.38rem;
      padding:0.6rem 0.75rem 0;
      box-sizing: border-box;
      .list-lb{
        display: flex;
        flex-wrap: wrap;
        border-bottom: 1px dashed rgba(116,105,248,0.15);
        padding:0.3rem 0;
        box-sizing: border-box;
        .lb-li{
          width: 33%;
          display: flex;
          align-items: center;
          margin-bottom: 0.6rem;
          span{
            color:#837fb1;
            font-size: 0.75rem;
            line-height: 1;
            margin-right:0.25rem;
          }
        }
      }
      .list-text{
        text-align: right;
        color:#666;
        font-size: 0.75rem;
        padding:0.68rem 0.2rem;
        box-sizing: border-box;
        span{
          color:#7469F8;
          font-size: 0.88rem;
        }
      }
    }
    .button-foot{
      padding:0.63rem 0.94rem;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-end;
      .foot-bm{
        width: 6rem;
        height: 2rem;
        background: #7469F8;
        color:#fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/cxbm/index.vue